$(function ()
{
	if (typeof FroalaEditor == "undefined") {
		return;
	}
	(function (global, factory)
	{
		typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('froala-editor')) :
			typeof define === 'function' && define.amd ? define(['froala-editor'], factory) :
				(factory(global.FroalaEditor));
	}(window, (function (FE)
	{
		'use strict';
		FE = FE && FE.hasOwnProperty('default') ? FE['default'] : FE;

		FE.PLUGINS.cleanup = function (editor)
		{
			/** @type {JQueryStatic} $ */
			var $ = editor.$;

			function _init()
			{
				editor.events.on('html.processGet', function (element)
				{
					$(element).find('lt-highlighter, lt-div, .lt-highlighter__canvas').remove();
				});
			}

			return {
				_init: _init,
			}
		}
	})));
});